import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonCriteriaService } from 'src/app/services/common/common-criteria.service';
import { RfiViewModalComponent } from './rfi-view-modal/rfi-view-modal.component';
import { RfiAddModalComponent } from './rfi-add-modal/rfi-add-modal.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { UserService } from 'src/app/services/user.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { devOnlyGuardedExpression } from '@angular/compiler';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rfi',
  templateUrl: './rfi.component.html',
  styleUrls: ['./rfi.component.scss']
})
export class RfiComponent implements OnInit {
  collapesedOrNot: boolean;
  columnDefs;
  operations;
  loperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  //StatusList:any[] = [] ; 
  advanceSearch;
  module: string;
  MODULE_ID: string;
  appid: string;
  userType: string;
  rfiForm: UntypedFormGroup;
  permission: string = "";
  Recordstate: number = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    public route: ActivatedRoute,
    private commonService: CommonService,
    private criteriaService: CommonCriteriaService,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {

    this.collapesedOrNot = false;
    this.rfiForm = new UntypedFormGroup({
      APPID: new UntypedFormControl(this.appid),
      TITLE: new UntypedFormControl(""),
      RAISED_BY: new UntypedFormControl(""),
      RAISED_FROM: new UntypedFormControl(""),
      RAISED_TO: new UntypedFormControl(""),
      STATUS: new UntypedFormControl("")
    });
    this.appid = this.commonService.appId;
    //  this.StatusList.push({label:"All",value:"" });
    //  this.StatusList.push({label:"Draft",value:"1"});
    //  this.StatusList.push({label:"Submitted",value:"2"}); 
    //this.StatusList.push({label:"Closed",value:"3"});
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.module = params['module'];
        //   this.appid = params['id'];
        if (this.module == "ist") {
          this.MODULE_ID = "2";
        }
        if (this.module == "grants") {
          this.MODULE_ID = "4";
        }
        if (this.module == "eap") {
          this.MODULE_ID = "5";
        }
      }
    });

    this.permission = "";
    var lper = this.commonService.getPagePermission("IST16");
    if (lper != null && lper) {
      this.permission = lper.toLowerCase();
    }

    this.userType = this.userService.getUserType();
    this.loperations = [];
    //this.setOperations();
    this.columnDefs = [
      {
        "headerName": "Title",
        "field": "TITLE"
      },
      {
        "headerName": "Raised By",
        "field": "RaisedBy"
      },
      {
        "headerName": "Raised On",
        "field": "CreatedDateStr"
      },
      {
        "headerName": "Status",
        "field": "StatusStr"
      }
    ];

    this.rfiForm.patchValue({
      APPID: this.appid
    });
    var form = this.rfiForm.value;
    this.setSearchSummary(form);
    if (this.permission == 'new') {
      this.operations = [{
        name: "Add RFI",
        id: "add",
      }].map((operation) => {
        return operation &&
          (operation.id === "add" || operation.id === "view_modal")
          ? {
            name: operation.name,
            callback: this[operation.id],
            self: this,
            disabled: "false",
          }
          : { name: operation.name, callback: this[operation.id], self: this };
      });
    }






  }

  // setOperations() {
  //   this.loperations = [];
  //     this.loperations.push({
  //       "name": "View",
  //       "id": "view"
  //     });
  //     if (this.permission !== 'view' && this.permission !== '') {
  //       this.loperations.push({
  //         "name": "Edit",
  //         "id": "edit"
  //       });
  //     }
  //     if (this.userType === "I") {
  //       if (this.permission !== 'view' && this.permission !== '') {
  //       this.loperations.push({
  //         "name": "Delete",
  //         "id": "delete"
  //       });
  //       this.loperations.push({
  //         "name": "Close",
  //         "id": "close"
  //       });

  //          ;
  //         this.loperations.push({
  //           "name": "Add New RFI",
  //           "id": "add"
  //         });
  //       }
  //   }
  //   this.operations = this.loperations.map(operation => {
  //     return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
  //   });
  // }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  view(RecordData: any) {

    this['self'].summaryService.getRFIByID('api/rfi/getviewcomment/' + RecordData['ID']).subscribe((result) => {

      if (result != null) {
        this.Recordstate = result['RECORD_STATE'];
      }

      this['self'].summaryService.getRFIByID('api/rfi/getrfibyid/' + RecordData['ID']).subscribe((res) => {

        var rfi = res;
        if ((RecordData['STATUS'] === 2 || RecordData['STATUS'] === 3) && this.Recordstate == 1) {
        const modalRef = this['self'].modalService.open(RfiViewModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-vlg right modal-right',
          animation: true,

        });
        modalRef.componentInstance.Content = {
          heading: 'View',
          content: { id: RecordData['ID'], appid: this['self'].appid, module: this['self'].module, rfiDetails: rfi }
        }
        modalRef.result.then(result => {
          this['self'].setSearchSummary(this['self'].rfiForm.value);
          //this.setSummary("");
        })
      }
      if (this.Recordstate == 2) {
        let modalRef = this['self'].modalService.open(RfiAddModalComponent, {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          windowClass: 'modal-vlg right modal-right',
          animation: true,

        });
        modalRef.componentInstance.Content = {
          heading: 'View',
          content: { id: RecordData['ID'], appid: this['self'].appid, module: this['self'].module, userType: this['self'].userType, rfiDetails: rfi }
        }
        modalRef.result.then(result => {
          this['self'].setSearchSummary(this['self'].rfiForm.value);
        })
      }
      });
      
    });
  }

  add() {
    let modalRef = this['self'].modalService.open(RfiAddModalComponent, {
      backdrop: false,
      keyboard: false,
      ignoreBackdropClick: true,
      windowClass: 'modal-llg right modal-right',
      animation: true,

    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {
        id: null, appid: this['self'].appid, module: this['self'].module,
        usertype: this['self'].userType
      }
    }
    modalRef.result.then(result => {
      this['self'].setSearchSummary(this['self'].rfiForm.value);
    })
  }

  edit(RecordData: any) {

    this['self'].summaryService.getRFIByID('api/rfi/getrfibyid/' + RecordData['ID']).subscribe((result) => {
      var rfi = result;
      if (RecordData['STATUS'] === 3) {
        // this['self'].modelRef =  this['self'].modalService.open(MessageBoxComponent, {

        // });
        // this['self'].modalRef.componentInstance.Content = 
        // { heading: '',
        //  content: { heading: '', description: 'Closed RFI cannot be edited.' } }
        // return;
        this['self'].commonService.ValidationBanner("Closed RFI cannot be edited");
      }
      if (RecordData['STATUS'] === 2) {
        let modalRef = this['self'].modalService.open(RfiViewModalComponent, {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          windowClass: 'modal-vlg right modal-right',
          animation: true,

        });
        modalRef.componentInstance.Content = {
          heading: 'Edit',
          content: {
            id: RecordData['ID'], appid: this['self'].appid, module: this['self'].module,
            userType: this['self'].userType, status: RecordData['STATUS'], rfiDetails: rfi
          }
        }
        modalRef.result.then(result => {
          this['self'].setSearchSummary(this['self'].rfiForm.value);
        })
      }
      if (RecordData['STATUS'] === 1) {
        let modalRef = this['self'].modalService.open(RfiAddModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-vlg right modal-right',
          animation: true,

        });
        modalRef.componentInstance.Content = {
          heading: 'Edit',
          content: { id: RecordData['ID'], appid: this['self'].appid, module: this['self'].module, userType: this['self'].userType, rfiDetails: rfi }
        }
        modalRef.result.then(result => {
          this['self'].setSearchSummary(this['self'].rfiForm.value);
        })
      }
    });
  }

  update_status() {
    //this['self'].summaryService.deleteMilestonesSummary(this['self'].selectedRow.id).subscribe(result => {
    this['self'].modalRef = this['self'].modalService.open(MessageBoxComponent,
      {});
    this['self'].modalRef.componentInstance.Content = {
      heading: 'Update Status',
      content: { heading: '', description: 'Do you want to close the RFI?' }
    }
    //})
  }

  submit_response() {
    //this['self'].summaryService.deleteMilestonesSummary(this['self'].selectedRow.id).subscribe(result => {
    this['self'].modalRef = this['self'].modalService.open(MessageBoxComponent, {
    });
    this['self'].modalRef.componentInstance.Content =
    {
      heading: 'Submit Response',
      content: { heading: '', description: 'Do you want to Submit the RFI?' }
    }
    //})
  }

  delete(RecordData: any) {
    if (RecordData['STATUS'] === 2) {
      this['self'].commonService.ValidationBanner("Submitted RFI cannot be deleted");
      return;
    }
    if (RecordData['STATUS'] === 3) {
      this['self'].commonService.ValidationBanner("Closed RFI cannot be deleted");
      return;
    }
    const id = RecordData['ID'];
    let name = RecordData['TITLE'];
    var modalRef = this["self"].modalRef = this["self"].modalService.open(DeleteBoxComponent,
      { backdrop: false });
    modalRef.componentInstance.Content = {
      heading: '',
      custommessage: 'Are you sure you want to delete the ' + name + '?',
      ProceedButtonName: "Delete",
      TerminateButtonName: "Cancel"
    }
    this["self"].modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.deleteRFI(id, this["self"].MODULE_ID).subscribe(result => {
          if (result.Status === 0) {
            this['self'].commonService.SuccessBanner("RFI " + name + " deleted successfully");
            this['self'].setSearchSummary(this['self'].rfiForm.value);
          }
          else {
            this["self"].commonService.ValidationBanner(result.Message);
            //this['self'].modalRef = this['self'].modalService.open(MessageBoxComponent, {   modalRef.componentInstance.Content = { heading: '', content: { heading: '', description: result.Message } } });
          }
        });
      }
    });
  }

  close(RecordData: any) {
    if (RecordData['STATUS'] === 3) {
      return;
    }
    const id = RecordData['ID'];
    let name = RecordData['TITLE'];
    this["self"].modalRef = this["self"].modalService.open(DeleteBoxComponent, {
      backdrop: false
    });
    this["self"].modalRef.componentInstance.Content =
    {
      custommessage: 'Do you want to close the RFI?',
      header: 'Close',
      ProceedButtonName: "Close",
      TerminateButtonName: "Cancel"
    }

    this["self"].modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.closeRFI(id, this["self"].MODULE_ID).subscribe(result => {
          if (result.Status === 0) {
            this['self'].commonService.SuccessBanner("RFI " + name + " closed successfully");
            this['self'].setSearchSummary(this['self'].rfiForm.value);
          }
          else {
            this["self"].commonService.ValidationBanner(result.Message);
            //this['self'].modalRef = this['self'].modalService.open(MessageBoxComponent, {   modalRef.componentInstance.Content = { heading: '', content: { heading: '', description: result.Message } } });
          }
        });
      }
    });
  }

  setSummary(filter: string) {
    let strfilter = "-1";
    if (filter !== "")
      strfilter = filter;
    this.summaryService.getRFI(strfilter, this.appid).subscribe(summary => {
      // this.rowData = summary;
      this.rowData = this.setOperations(summary);
    });
  }

  setSearchSummary(formData) {
    this.summaryService.getRFIAdvSearch(formData).subscribe(summary => {
      //this.rowData = summary;
      this.rowData = this.setOperations(summary);
    });
  }

  setSearch() {
    this.SearchClear();
    this.rfiForm.patchValue({
      APPID: this.appid
    });
    var form = this.rfiForm.value;
    this.summaryService.getRFIAdvSearch(form).subscribe(summary => {
      this.rowData = summary;
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.rfiForm = new UntypedFormGroup({
      APPID: new UntypedFormControl(this.appid),
      TITLE: new UntypedFormControl(""),
      RAISED_BY: new UntypedFormControl(""),
      RAISED_FROM: new UntypedFormControl(""),
      RAISED_TO: new UntypedFormControl(""),
      STATUS: new UntypedFormControl("")
    });
  }

  AdvanceSearch() {
    this.rfiForm.patchValue({
      APPID: this.appid
    });
    this.setSearchSummary(this.rfiForm.value);
  }
  onRowDoubleClicked($event) {

  }


  setOperations(RawData: any): any {
    this.setDef(this.loperations);
    RawData.forEach((element) => {

      let loperations = [
        {
          name: "View",
          id: "view",
        },
      ];
      element["Operations"] = this.setDef(loperations);

      if (this.userType === "I") {
        //internal
        if (this.permission !== 'view' && this.permission !== '') {
          if (element.StatusStr.toLowerCase() != "closed") {
            let tempoperations = [
              {
                name: "View",
                id: "view",
              },
              {
                name: "Edit",
                id: "edit",
              },
              {
                name: "Delete",
                id: "delete",
              },
              {
                name: "Close",
                id: "close",
              }
            ];
            element["Operations"] = this.setDef(tempoperations);
          }
        }
      }
      else {
        //eternal
        if (this.permission !== 'view' && this.permission !== '') {
          if (element.StatusStr.toLowerCase() != "closed") {
            let tempoperations = [
              {
                name: "View",
                id: "view",
              },
              {
                name: "Edit",
                id: "edit",
              }
            ];
            element["Operations"] = this.setDef(tempoperations);;
          }
        }

      }
    });
    return RawData;
  }

  setDef(loperations: any): any {
    let operations = loperations.map((operation) => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false",
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });

    // this.operations = this.loperations.map(operation => {
    //   return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    // });

    return operations;
  }

}
